<!-- 简历编辑页面 - 上传照片组件 -->
<template>
  <el-upload
    ref="upload"
    :action="$baseAPI + '/api/base/Upload'"
    :headers="{ Authorization: $store.state.token }"
    class="upload-demo"
    :class="{ 'upload-then-hide': tempArr.length >= limit && uploadThenHide }"
    :on-exceed="handleExceed"
    :before-upload="beforeUpload"
    :on-error="handleError"
    :on-success="handleSuccess"
    :on-remove="handleRemove"
    :on-preview="handlePreview"
    :file-list="fileList"
    :limit="limit"
    list-type="picture"
  >
    <el-button icon="el-icon-plus" class="inline-block" style="width: 100%" :style="buttonStyle">点击上传</el-button>
    <slot name="tip"></slot>
    <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div> -->
  </el-upload>
</template>

<script>
import { fileDownload } from '@/utils/tool';

export default {
  name: 'ResumePhoto',
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    // 最大允许上传个数
    limit: {
      type: Number,
      default: 1,
    },
    // 文件大小限制，单位 MB
    fileSize: {
      type: Number,
      default: 5,
    },
    // 文件类型限制
    fileType: {
      type: Array,
      default: () => ['jpg', 'gif', 'jpeg', 'png', 'bmp'],
    },
    // 上传后隐藏上传按钮
    uploadThenHide: {
      type: Boolean,
      default: false,
    },
    // 组件渲染前已有的文件列表
    fileListArray: {
      type: Array,
      default: () => [],
    },
    // 上传按钮样式
    buttonStyle: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      fileList: [], // 回显文件列表
      tempArr: [], // 临时文件列表（父组件提交表单用） eg:['http://example.com/xxx.jpg','http://example.com/xxx2.jpg']
    };
  },
  methods: {
    fileDownload,
    // 文件列表移除文件时的钩子
    handleRemove(file, fileList) {
      this.tempArr.forEach((item, index) => {
        if (item === file.url) {
          this.tempArr.splice(index, 1);
          this.$emit(
            'input',
            this.tempArr.map((item) => item.url),
          );
        }
      });
    },
    // 文件超出个数限制时的钩子
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 ${this.limit} 个文件！`);
    },
    // 上传文件之前的钩子，参数为上传的文件，若返回 false 或者返回 Promise 且被 reject，则停止上传。
    beforeUpload(file) {
      // 校验文件类型
      if (this.fileType && file && this.fileType.indexOf(file.type.split('/')[1]) === -1) {
        this.$message.warning(`文件格式不正确！请上传 ${this.fileType.join(', ')} 格式的文件`);
        return false;
      }
      // 校验文件大小
      if (this.fileSize && file && file.size / 1024 / 1024 > this.fileSize) {
        this.$message.warning(`文件大小超过限制！请上传不超过 ${this.fileSize} MB 的文件`);
        return false;
      }
    },
    // 文件上传失败时的钩子
    handleError(err, file, fileList) {
      this.$message.error('上传失败！请重试');
    },
    // 文件上传成功时的钩子
    handleSuccess(response, file, fileList) {
      if (response.status == 200) {
        this.$message.success('上传成功');
        this.objAddItem(file);
      } else {
        this.$message.error(response.msg);
        fileList.splice(fileList.length - 1, 1);
      }
    },
    // 将文件对象添加到临时数组中
    objAddItem(file) {
      this.tempArr.push(file.response.data);
      this.$emit('input', this.tempArr);
    },
    // 点击下载文件（同源情况下）
    handlePreview(file) {
      fileDownload(file.url, file.name);
    },
    // 回显已有的图片
    echoFile() {
      this.tempArr = this.value;
      this.fileList = this.value.map((item) => ({
        name: item.match(/([^\/]+)$/)[1],
        url: item,
      }));
    },
  },
  mounted() {
    this.echoFile();
  },
  watch: {
    value() {
      this.echoFile();
    },
  },
};
</script>

<style lang="scss" scoped>
.upload-then-hide ::v-deep .el-upload {
  display: none;
}
</style>
